import { CARCS, NATERA_TAGS } from '../config'
import { byCode, type CodeOption } from './code-utils'
import { getBaseCarcCode } from './get-mapped-rarc-options'

const CARC_OPTIONS: CodeOption[] = CARCS.map((c) => ({
  label: `${c.code} - ${c.label}`,
  value: c.code,
  description: c.description,
  occurrences: c.occurrences ?? 0,
})).sort(byCode)

const TAGGING_CARC_OPTIONS: CodeOption[] = (() => {
  const baseCodeMap = new Map<string, (typeof CARCS)[number]>()
  for (const carc of CARCS) {
    const base = getBaseCarcCode(carc.code)
    if (!baseCodeMap.has(base)) {
      baseCodeMap.set(base, carc)
    }
  }
  return Array.from(baseCodeMap.entries())
    .map(([base, carc]) => ({
      label: `${base} - ${carc.label}`,
      value: base,
      description: carc.description,
      occurrences: carc.occurrences ?? 0,
    }))
    .sort(byCode)
})()

export function getTaggingCarcOptions(serverValues?: string[]): CodeOption[] {
  if (!serverValues || serverValues.length === 0) {
    return TAGGING_CARC_OPTIONS
  }
  const existingBases = new Set(TAGGING_CARC_OPTIONS.map((o) => o.value))
  const additionalOptions: CodeOption[] = []
  for (const sv of serverValues) {
    const base = getBaseCarcCode(sv)
    if (!existingBases.has(base)) {
      existingBases.add(base)
      additionalOptions.push({ label: base, value: base, description: '', occurrences: 0 })
    }
  }
  if (additionalOptions.length === 0) return TAGGING_CARC_OPTIONS
  return [...TAGGING_CARC_OPTIONS, ...additionalOptions].sort(byCode)
}

export function getCarcOptions(serverValues: string[] | undefined) {
  if (!serverValues || serverValues.length === 0) {
    return CARC_OPTIONS
  }
  const additionalOptions = serverValues
    .filter((value) => !CARC_OPTIONS.some((c) => c.value === value))
    .map((value) => {
      const carc = NATERA_TAGS.find((c: (typeof NATERA_TAGS)[number]) => c.code === value)
      if (carc) {
        return {
          label: `${carc.code} - ${carc.label}`,
          value: carc.code,
          description: carc.description,
          occurrences: carc.occurrences ?? 0,
          hidden_from_search: true,
        }
      }
      // If not found, we still need to show the value in the dropdown
      return {
        label: value,
        value: value,
        description: '',
        occurrences: 0,
        hidden_from_search: false,
      }
    })
  return [...CARC_OPTIONS, ...additionalOptions].sort(byCode)
}
